import { render, staticRenderFns } from "./Favorite.vue?vue&type=template&id=2242d678&scoped=true&"
import script from "./Favorite.vue?vue&type=script&lang=js&"
export * from "./Favorite.vue?vue&type=script&lang=js&"
import style0 from "./Favorite.vue?vue&type=style&index=0&id=2242d678&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2242d678",
  null
  
)

export default component.exports